import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useViewStore } from '../../Contexts/ViewContext'
import type { DirectLineAttachment } from '../../../models/directLine'
import renderAttachment from '../../Middlewares/attachmentMiddleware'
import type { NamedListElementType } from '../NamedListAttachment'
import Carousel from '../../AnswerPanel/Carousel'
import Card from '../../AnswerPanel/Card'
import SearchBar from '../Utils/SearchBar'

interface CarouselContainerProps {
  title?: string
  attachments: Array<DirectLineAttachment>
  history?: boolean
  grid?: boolean
  showSearchBar: boolean
  triggerScroll?: () => void
}

const CarouselContainer = ({
  title,
  attachments,
  history,
  grid,
  showSearchBar,
  triggerScroll
}: CarouselContainerProps): JSX.Element => {
  const currentDeviceType = useViewStore((state) => state.currentDeviceType)
  const [height, setHeight] = useState<number>(0)
  const [elements, setElements] = useState<Array<NamedListElementType>>([])
  const [forcedCurrentCardInCarousel, setForcedCurrentCardInCarousel] =
    useState<number>(0)
  const [carouselCardWidth, setCarouselCardWidth] = useState<number>(0)
  const timerRef = useRef<NodeJS.Timeout>()
  const carouselRef: React.MutableRefObject<HTMLDivElement | null> =
    useRef(null)

  useLayoutEffect(() => {
    setHeight(0)
    if (attachments.length) {
      timerRef.current && clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => {
        carouselRef.current && setHeight(carouselRef.current.clientHeight)
      }, 500)
    }

    return () => {
      timerRef.current && clearTimeout(timerRef.current)
    }
  }, [attachments, currentDeviceType])

  useEffect(() => {
    triggerScroll?.()
  }, [height])

  useEffect(() => {
    const tempElements: Array<NamedListElementType> = []
    if (showSearchBar) {
      attachments.forEach((attachment) => {
        attachment.content?.value?.forEach((val) => {
          tempElements.push(val)
        })
      })
      setElements(tempElements)
    } else {
      setElements([])
    }
  }, [attachments, showSearchBar])

  return (
    <React.Fragment>
      <Carousel
        ref={carouselRef}
        history={history}
        draft={height === 0}
        grid={grid}
        gridTitle={title}
        forcedCurrentCard={forcedCurrentCardInCarousel}
        setForcedCurrentCardInCarousel={setForcedCurrentCardInCarousel}
        setCarouselCardWidth={setCarouselCardWidth}
      >
        {height === 0
          ? attachments.map((attachment, key) => {
              return (
                <Card key={key + 100} className='rf-w-full'>
                  {renderAttachment({
                    attachment: attachment,
                    history: history
                  })}
                </Card>
              )
            })
          : attachments.map((attachment, key) => {
              return (
                <Card key={key} className='rf-w-full'>
                  {renderAttachment({
                    attachment: attachment,
                    history: history,
                    height: height
                  })}
                </Card>
              )
            })}
      </Carousel>

      {/* Search bar */}
      {showSearchBar && height !== 0 && (
        <SearchBar
          elements={elements}
          elementsByCard={attachments[0].content?.value?.length}
          carouselCardWidth={carouselCardWidth}
          setCardToShow={setForcedCurrentCardInCarousel}
        />
      )}
    </React.Fragment>
  )
}

export default CarouselContainer
